import { AuthState, VisAuthService } from '@vis-auth/vis-auth';
import { getAuthService, getAuthConfig, initiateAuthService } from './authService';

export type HandleAuthenticationResult = {
  authService: VisAuthService;
  authState: AuthState;
};

function setupUnauthorizedFetchWrapper(authService: VisAuthService): void {
  const globalFetch = window.fetch;
  window.fetch = async (...params) => {
    const response = await globalFetch(params[0], params[1]);
    if (response.status === 401) {
      await authService.logout();
    }
    authService.delaySessionWarning().finally(() => {
      // Ignore errors as 'all' expected errors are handled in the authService
    });
    return response;
  };
}

export async function handleAuthentication(): Promise<HandleAuthenticationResult> {
  const authConfig = getAuthConfig();
  initiateAuthService(authConfig);

  const authService = getAuthService();
  setupUnauthorizedFetchWrapper(authService);

  await authService.handleAuthentication();

  if (authService.state.state === 'authenticated') {
    // Listen for route changes and delay session timeout.
    window.addEventListener('popstate', () => {
      // eslint-disable-next-line no-void
      void authService.delaySessionWarning();
    });
  }

  return {
    authService,
    authState: authService.state,
  };
}
